'use strict';
const positive = function positive(key) {
		return key >= 0;
	},
	negative = function negative(key) {
		return !positive(key);
	},
	absCompare = function (a, b) {
		return Math.abs(a) - Math.abs(b);
	},
	safeSort = function (contentIdea) {
		const childKeys = Object.keys(contentIdea.ideas).map(parseFloat),
			sortedChildKeys = childKeys.filter(positive).sort(absCompare).concat(childKeys.filter(negative).sort(absCompare));
		return sortedChildKeys.map(function (key) {
			return contentIdea.ideas[key];
		});
	};
module.exports = function sortedSubIdeas(contentIdea) {

	if (!contentIdea.ideas) {
		return [];
	}
	return safeSort(contentIdea);
};

